import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useT } from "@/i18n";
import { usePageMeta, eur } from "@/lib/format";
import { PageHeader } from "@/components/StatCard";
import { EmptyState } from "@/components/EmptyState";
import { Spinner } from "@/components/Spinner";
import { Boxes, Users, ArrowRight } from "lucide-react";

export default function CollabPackages() {
  const t = useT();
  usePageMeta(t("cov.packages_title"));
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/public/collab-offerings")
      .then((r) => setItems(Array.isArray(r.data) ? r.data : (r.data?.offerings || [])))
      .catch(() => setItems([]));
  }, []);

  if (items === null) return <Spinner label={t("common.loading")} />;

  return (
    <div className="space-y-6" data-testid="collab-packages-screen">
      <PageHeader title={t("cov.packages_title")} subtitle={t("cov.packages_sub")} />
      {items.length === 0 ? (
        <EmptyState icon={Boxes} title={t("cov.none")} />
      ) : (
        <div className="grid gap-4 sm:grid-cols-2">
          {items.map((o) => (
            <Link key={o.id} to={`/app/collab-package/${o.id}`} data-testid={`collab-pkg-${o.id}`}
              className="group flex flex-col gap-3 rounded-2xl border border-border bg-card p-5 transition-colors hover:bg-accent/30">
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-display text-lg text-foreground">{o.title}</h3>
                <Boxes className="h-5 w-5 shrink-0 text-sage-light" />
              </div>
              {o.description ? <p className="line-clamp-2 text-sm text-muted-foreground">{o.description}</p> : null}
              <div className="mt-auto flex items-center justify-between">
                <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
                  <Users className="h-3.5 w-3.5" /> {(o.coaches || []).length || o.coach_count || 1}
                </span>
                <span className="inline-flex items-center gap-1 font-display text-lg font-semibold text-primary">
                  {eur(o.total_price_cents || 0)} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
